import styled from 'styled-components';
import { breakpoints } from '@/styles/breakpoints';

const BearsNotFound = styled.div`
  display: grid;
  row-gap: ${({ theme }) => theme.spacings.base};
  padding: ${({ theme }) => theme.spacings.x4}
    ${({ theme }) => theme.spacings.x2} ${({ theme }) => theme.spacings.x2};
  border: 2px solid #fff;

  ${breakpoints.MD} {
    padding: ${({ theme }) => theme.spacings.x7}
      ${({ theme }) => theme.spacings.x4} ${({ theme }) => theme.spacings.x4};
  }

  ${breakpoints.LG} {
    grid-template-columns: 1fr 440px;
    grid-template-areas:
      'title image'
      'subtitle image';
    align-items: start;
    align-content: start;
    grid-template-rows: auto 1fr;

    padding: ${({ theme }) => theme.spacings.x4};
  }
`;

const Title = styled.h3`
  color: #5a5a5a;

  ${breakpoints.MD} {
    font-size: 62px;
    line-height: 48px;
  }

  ${breakpoints.LG} {
    grid-area: title;
    margin-top: ${({ theme }) => theme.spacings.x3};
  }
`;

const Subtitle = styled.div`
  color: #5a5a5a;

  ${breakpoints.LG} {
    grid-area: subtitle;
  }
`;

const Gif = styled.div`
  margin-top: ${({ theme }) => theme.spacings.x6};
  position: relative;
  background-color: #1e3163;
  border-radius: ${({ theme }) => theme.spacings.x4};
  overflow: hidden;
  text-align: center;
  padding-top: 35px;

  ${breakpoints.LG} {
    grid-area: image;
    margin-top: 0;
  }

  & > span {
    bottom: -6px;

    img {
      height: 247px !important;
      width: 247px !important;

      ${breakpoints.MD} {
        height: 320px !important;
        width: 320px !important;
      }
    }
  }
`;

export { BearsNotFound, Title, Subtitle, Gif };
